import styled, { css } from 'styled-components';

import {
  CENTRED_LAYOUT_QUERY,
  COMPOSER_MAX_WIDTH,
  DOWNWARD_PANEL_QUERY,
  LAYOUT_TRANSITION,
  QUESTION_PANEL_BLOCK_HEIGHT,
  QUESTION_PANEL_BLOCK_HEIGHT_STACKED,
  QUESTION_PANEL_GAP,
  SMALL_SCREEN_QUERY,
} from '@/utils/constants';

// INFO: ChatWindowWrapper's own padding. The Centred Layout's reservation is measured against it, so both
// read from here.
const CHAT_WINDOW_PADDING = '2rem';

const centredUnstarted = css`
  @media ${CENTRED_LAYOUT_QUERY} {
    padding-bottom: calc(${CHAT_WINDOW_PADDING} + ${QUESTION_PANEL_GAP} + ${QUESTION_PANEL_BLOCK_HEIGHT});

    @media ${SMALL_SCREEN_QUERY} {
      padding-bottom: calc(${CHAT_WINDOW_PADDING} + ${QUESTION_PANEL_GAP} + ${QUESTION_PANEL_BLOCK_HEIGHT_STACKED});
    }
  }
`;

export const ChatWindowWrapper = styled.div<{ $isUnstarted: boolean }>`
  padding: ${CHAT_WINDOW_PADDING};
  border-radius: 8px;
  /* Subtracted header's and rio toolkit internal padding from the height of the messages section */
  height: calc(100dvh - 50px - 60px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: auto;
  transition: padding-bottom ${LAYOUT_TRANSITION} ease;
  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
  @media ${CENTRED_LAYOUT_QUERY} {
    justify-content: center;
  }

  ${({ $isUnstarted }) => $isUnstarted && centredUnstarted}
`;

const collapsedUnstarted = css`
  @media ${DOWNWARD_PANEL_QUERY} {
    flex-grow: 0;
    padding-right: 0;
    margin-bottom: 1.75rem;
  }
`;

export const ContentWrapper = styled.div<{ $isUnstarted: boolean }>`
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-right: 2rem;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 1.5rem;

  transition:
    flex-grow ${LAYOUT_TRANSITION} ease,
    padding-right ${LAYOUT_TRANSITION} ease,
    margin-bottom ${LAYOUT_TRANSITION} ease;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: var(--gray-light);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-track {
    border-radius: 4px;
  }

  &::-webkit-scrollbar-button {
    display: none;
  }

  scrollbar-width: thin;
  scrollbar-color: var(--gray-light) var(--gray-lighter);

  ${({ $isUnstarted }) => $isUnstarted && collapsedUnstarted}
`;

export const MessagesSection = styled.div`
  flex-grow: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const narrowedUnstarted = css`
  max-width: ${COMPOSER_MAX_WIDTH};
`;

export const ComposerSection = styled.div<{ $isUnstarted: boolean }>`
  width: 100%;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
  flex-shrink: 0;

  transition: max-width ${LAYOUT_TRANSITION} ease;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }

  ${({ $isUnstarted }) => $isUnstarted && narrowedUnstarted}
`;
